var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRei(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.991 14.133c.001 1.242-1.118 2.247-2.496 2.247h-7.498v-4.49h7.498c1.38 0 2.497 1.004 2.497 2.243zm5.936 8.378C29.423 20.458 31 17.514 31 14.233 31 8.028 25.404 3 18.502 3H1v26.776h9.998v-4.333h7.576l2.612 4.325h9.806l-4.066-7.257z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRei);
export default __webpack_public_path__ + "static/media/REI.7b2d1e30d34e234f83b2dc8d3ed6dd76.svg";
export { ForwardRef as ReactComponent };